import React from "react";
import KundaliChart from "../../KundaliChart";

/**
 * Renders an AI-emitted natal kundali message (North-Indian style chart +
 * birth-detail strip + intro text).
 */
const KundaliChartMessage = ({ payload, text }) => {
  const k = payload?.kundali;
  if (!k) return null;
  const isMobile = typeof window !== "undefined" && window.innerWidth < 640;
  return (
    <div className="max-w-[92%] sm:max-w-[88%] bg-gradient-to-br from-[#FFF6E0] to-[#FFE9B5] border border-amber-300 rounded-2xl rounded-bl-sm px-3 sm:px-4 py-3 shadow-sm" data-testid="kundali-card">
      <p className="label-eyebrow !text-[#7C2D12] !text-[10px]">
        Your kundali · North-Indian style
      </p>
      <p className="text-xs text-[#3F2D1B] mt-1.5 mb-3 leading-relaxed">{text}</p>
      <div className="bg-white/70 rounded-md p-2 inline-block">
        <KundaliChart kundali={k} size={isMobile ? 240 : 300} style="north" showToggle={false} />
      </div>
      <div className="grid grid-cols-2 gap-x-3 gap-y-1 mt-3 text-[11px] text-[#3F2D1B]">
        <div>
          <span className="text-muted">Lagna:</span>{" "}
          <span className="font-medium">
            {k.lagna?.rashi} {k.lagna?.degrees_in_rashi?.toFixed?.(1)}°
          </span>
        </div>
        <div>
          <span className="text-muted">Moon:</span>{" "}
          <span className="font-medium">{k.moon?.rashi}</span>
        </div>
        <div>
          <span className="text-muted">Nakshatra:</span>{" "}
          <span className="font-medium">
            {k.moon?.nakshatra} (p{k.moon?.pada})
          </span>
        </div>
        <div>
          <span className="text-muted">Dasha:</span>{" "}
          <span className="font-medium">
            {k.current_mahadasha?.lord} → {k.current_antardasha?.lord}
          </span>
        </div>
      </div>
    </div>
  );
};

export default KundaliChartMessage;
